'use client';

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FiX } from "react-icons/fi";

const PopupOverlay = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  type,
  closePopup,
  loading,
  children,
  showCloseIcon = false,
}) => {
  const typeStyles = {
    primary:
      "border-[var(--accent-light)] bg-[var(--accent-transparent-2)] text-[var(--accent-light)]",
    success: "green-400 text-green-400",
    danger: "red-400 text-red-400",
    warning: "yellow-400 text-yellow-400",
    info: "indigo-400 text-indigo-400",
    default: "white text-white",
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closePopup();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [closePopup]);

  return ReactDOM.createPortal(
    <div
      onClick={closePopup}
      className="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm z-[999999] transition-all"
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={`relative p-6 rounded-lg shadow-lg border ${typeStyles[type]} border border-color-97 bg-color-95 w-[calc(100%-2rem)] md:w-[500px] max-w-[500px] max-h-[80vh] overflow-y-auto`}
      >
        {showCloseIcon && (
          <button
            onClick={closePopup}
            className="absolute top-4 right-4 p-1 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
          >
            <FiX size={20} className="text-color-2" />
          </button>
        )}
        
        <h2 className="text-xl font-semibold">{title}</h2>
        {children ? (
          <div className="mt-2 text-color-2">{children}</div>
        ) : (
          <p className="mt-2 text-color-2 whitespace-pre-line break-words">{message}</p>
        )}
        <div className="mt-4 flex justify-end gap-2">
          {onCancel && (
            <button
              onClick={onCancel}
              className="px-3 py-1 rounded-md bg-color-97 border border-color-50 text-color-2 hover:opacity-60 cursor-pointer"
            >
              {cancelText}
            </button>
          )}
          {onConfirm && (
            <button
              onClick={onConfirm}
              className="px-3 py-1 rounded-md bg-color-97 border border-color-50 hover:opacity-60 cursor-pointer"
            >
              {loading ? "loading" : confirmText}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PopupOverlay;
